import PropTypes from 'prop-types';
import React from 'react';
import SignUpStep from './SignUpStep';
import '../../LeadVettingPage/components/LeadVettingStyle.less';
import styles from '../../LeadVettingPage/components/LeadVettingFormStyles.module.less';

class SignUpFlowSteps extends React.Component {
  render() {
    const { props } = this;
    const onSubmitSignup = (values) => {
      const allValues = { ...values, product: props.product };
      props.submitSignUp(allValues);
    };

    return (
      <>
        <div className={styles.form}>
          <SignUpStep
            isLoading={props.isLoading}
            onSubmit={(values) => onSubmitSignup(values)}
            fields={props.fields}
            product={props.product}
            updateFields={props.updateFields}
            prepopulatedFields={props.prepopulatedFields}
          />
        </div>
      </>
    );
  }
}

SignUpFlowSteps.propTypes = {
  submitSignUp: PropTypes.func,
  fields: PropTypes.object,
  product: PropTypes.string,
  isLoading: PropTypes.bool,
  updateFields: PropTypes.func,
  prepopulatedFields: PropTypes.object,
};

export default SignUpFlowSteps;
